// Libraries
import { Box, Typography } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import React from "react";

// Custom
import { EditVariants } from "Custom/StylesAppSpecific/EditVariants";
import { TypographyVariants } from "Custom/StylesAppSpecific/TypographyVariants";
import { DelglazeStyle } from "./DelglazeStyle";

import { BQSCheckBox } from "Custom/Views/Primitives/CheckBoxes/BQSCheckBox";
import { BQSCheckBoxes } from "Custom/Views/Primitives/CheckBoxes/BQSCheckBoxes";
import { BQSEditNumber } from "Custom/Views/Primitives/Edits/BQSEditNumber";

import { ProductsCommonViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/RoofSystemSubViewModels/ProductsCommonViewModel";
import { DelglazeViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/RoofSystemSubViewModels/DelglazeViewModel";
import { BQSRow } from "Custom/Views/Primitives/Row/BQSRow";

interface IProps {
    className?: string;
    commonViewModel: ProductsCommonViewModel;
    viewModel: DelglazeViewModel;
}

export const Delglaze: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const editVariants = EditVariants();
    const typopgraphyVariants = TypographyVariants();
    const delglazeStyle = DelglazeStyle();

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <Box className={delglazeStyle.root}>
            <Box>
                <Typography className={typopgraphyVariants.productSelectorh2} variant="h2">
                    Delglaze rooflight coating system
                </Typography>
            </Box>
            <Box>
                <BQSCheckBoxes displayName="">
                    <BQSCheckBox
                        displayName="Would you like to coat the rooflights? (<a href='https://www.hdsharman.co.uk/wp-content/uploads/2018/04/Delglaze-Specification-Sept-20.pdf' target='_blank'>view system specification</a>)"
                        execute={props.commonViewModel.setDelglazeProductRequired}
                        isSelected={props.viewModel.productRequired}
                    />
                </BQSCheckBoxes>
            </Box>
            {props.commonViewModel.canDisplayDelglazeRooflightAreaMeterage && (
                <BQSRow>
                    <BQSEditNumber
                        className={editVariants.bqsEditNumberNoLabel}
                        displayName=""
                        endAdornment={`<div class="${editVariants.bqsSuperScriptAdornment}">m<sup>2</sup> of rooflights</div>`}
                        execute={props.commonViewModel.setRooflightSquareMeterage}
                        minimumValue={0}
                        value={props.viewModel.rooflightSquareMeterage}
                    />
                </BQSRow>
            )}
        </Box>
    ));

    // #endregion Render Result
};
